import React, { createContext, useState, useMemo, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', theme);
      document.documentElement.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
    }
  }, [theme]);

  const themeConfig = useMemo(() => {
    switch (theme) {
      case 'dark':
        return {
          name: 'dark',
          backgroundImage: 'none',
          color: '#ffffff',
        };
      case 'dawn':
        return {
          name: 'dawn',
          backgroundImage: 'none',
          color: '#ffffff',
        };
      case 'light':
      default:
        return {
          name: 'light',
          backgroundImage: 'none',
          color: '#000000',
        };
    }
  }, [theme]);

  const toggleTheme = (newTheme) => {
    setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme: themeConfig, toggleTheme, themeName: theme }}>
      {children}
    </ThemeContext.Provider>
  );
};
